import { FormControl, MenuItem, Select, TextField } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";

import React from "react";
import { filterConstants, DateConstants } from "../../constants/AppConstants";
interface propTypes {
  type: string;
  styles: any;
  onInputChange: (data: any) => void;
  value: any;
  inputPlaceHolder?: string;
  tittle?: string;
  options?: any;
}
export const TextInputField = (props: propTypes) => {
  const {
    styles,
    type,
    onInputChange,
    inputPlaceHolder,
    value,
    tittle,
    options,
  } = props;
  return (
    <>
      {type !== filterConstants.Select ? (
        <TextField
          sx={styles}
          type={type}
          size="small"
          placeholder={inputPlaceHolder}
          value={value}
          onChange={(e) => onInputChange(e)}
          InputProps={
            type === "date" || type === "Date"
              ? {
                  inputProps: {
                    max: DateConstants.maxDate,
                  },
                }
              : {}
          }
        />
      ) : (
        <>
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel id="demo-simple-select-helper-label">
              {tittle}
            </InputLabel>
            <Select
              sx={styles}
              value={value}
              label={tittle}
              onChange={(e) => onInputChange(e)}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              {options?.map((item: any) => {
                return <MenuItem value={item.id}>{item.label} </MenuItem>;
              })}
            </Select>
          </FormControl>
        </>
      )}
    </>
  );
};
